"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundRectToInt = exports.roundRectSizeToInt = exports.roundVector2dToInt = exports.roundPosToInt = exports.roundToInt = void 0;
var convert_shape_1 = require("./convert-shape");
var roundToInt = function (n) { return 0 | (n + 0.5); };
exports.roundToInt = roundToInt;
var roundPosToInt = function (from) {
    return (0, convert_shape_1.updatePosElementwise)(from, exports.roundToInt);
};
exports.roundPosToInt = roundPosToInt;
var roundVector2dToInt = function (from) {
    return (0, convert_shape_1.updateVector2dElementwise)(from, exports.roundToInt);
};
exports.roundVector2dToInt = roundVector2dToInt;
var roundRectSizeToInt = function (from) {
    return (0, convert_shape_1.updateRectSizeElementwise)(from, exports.roundToInt);
};
exports.roundRectSizeToInt = roundRectSizeToInt;
var roundRectToInt = function (from) {
    return (0, convert_shape_1.updateRectElementwise)(from, exports.roundToInt);
};
exports.roundRectToInt = roundRectToInt;
